import React from 'react';
import loadable from '@loadable/component';
import DefaultLoading from '../../elements/defaultLoading/defaultLoading';

// Lazy-load the PCS component with a fallback loader
const PcsRoutes = loadable(() => import('./pcs'), {
  fallback: <DefaultLoading />,
});

export default PcsRoutes;